import * as React from "react";
import { Table } from "../../newcomponents/table/table";
import { BillingAccountSummary } from "../../schema/types/account";
import { InternalLink } from "../../newcomponents/table/components/InternalLink";
import { useNavigate } from "react-router-dom";
import { sortBy } from "lodash";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchAccountSummaries, selectAccountSummaries } from "../../store/userDataSlice";
import { Button } from "antd";
import { PlusCircleOutlined, SyncOutlined } from "@ant-design/icons";

export const AccountList: React.FC = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const accountSummaries = useAppSelector(selectAccountSummaries);
  const accountTableItems: BillingAccountSummary[] = sortBy(accountSummaries, (i) => i.accountName);
  const userType = useAppSelector((state) => state.user.type);

  React.useEffect(() => {
    if (userType !== "user") {
      dispatch(fetchAccountSummaries());
    }
  }, []);

  return (
    <>
      <Table<BillingAccountSummary>
        title={"Billing Accounts"}
        hideSettings
        data={accountTableItems}
        headerRenderer={() => {
          return (
            <>
              <Button
                type="default"
                onClick={() => {
                  dispatch(fetchAccountSummaries());
                }}
                icon={<SyncOutlined />}
              >
                Refresh
              </Button>
              <Button
                type="primary"
                className="action"
                onClick={() => navigate(`/home/account/-create`)}
                icon={<PlusCircleOutlined />}
              >
                New
              </Button>
            </>
          );
        }}
        selectMode={`none`}
        tableId={`home-account-list-update2`}
        enableFilter
        columns={[
          {
            id: "name",
            label: "Name",
            cell: (p) => {
              const accountSummary = p.row.original;
              const value = accountSummary.accountName || accountSummary.fullName || accountSummary.id;

              return (
                <div className="flex flex-col justify-center" style={{ height: 56 }}>
                  <InternalLink label={value} to={`/home/account/${accountSummary.id}`} />
                </div>
              );
            },
          },
          {
            id: "id",
            label: "Id",
          },
        ]}
      />
    </>
  );
};
